export function validMonthKey(value) {
  return typeof value === "string" && /^[1-9]\d{3}-(0[1-9]|1[0-2])$/.test(value);
}
export function selectedMonth(value, fallback) {
  return validMonthKey(value) ? value : fallback;
}
export function calendarMonthDate(month, today) {
  return month === today.slice(0, 7) ? today : `${month}-01`;
}
